import { useNavigate } from "react-router-dom"
import ArrowLeftIcon from "@/components/icons/arrow-left"

interface InnerScreenHeaderProps {
  title: string;
  to: string;
  tryBackFirst?: boolean;
}

export default function InnerScreenHeader({
  title,
  to,
  tryBackFirst = true,
}: InnerScreenHeaderProps) {
  const navigate = useNavigate()

  const goBackOrTo = () => {
    if (history.length > 1 && tryBackFirst) {
      navigate(-1)
    } else {
      navigate(to)
    }
  }

  return (
    <div className="flex flex-row justify-start">
      <button
        className="flex flex-row gap-1 items-center"
        onClick={goBackOrTo}
        data-testid="back"
      >
        <ArrowLeftIcon />
        {title}
      </button>
    </div>
  )
}
